import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgPillsGlyph from './svgs/PillsGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var pillsGlyph = (props => useIcon(SvgPillsGlyph, SvgPillsGlyph, props));

export { pillsGlyph as default };
